import React from "react";

function Battle() {
  return (
    <>
      <div className="bx">
        PUB-G <br />
        4.2/5
      </div>
      <div className="bx">
        Fortnite <br />
        4.0/5
      </div>
      <div className="bx">
        Call of Duty: Warzone <br />
        4.4/5
      </div>
    </>
  );
}

export default Battle;
